import { styled } from 'styled-components';
import THEME from '../../theme.js';
export const Guide = styled.ol `
  counter-reset: step;
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
`;
export const GuideStep = styled.li `
  counter-increment: step;
  position: relative;
  padding: 0 0 20px 42px;
  margin: 18px 0 0;
  > b {
    display: block;
    font-size: 15px;
    margin-bottom: 7px;
  }
  p {
    font-size: 13px;
    color: ${THEME.TEXT_MUTED};
    line-height: 1.65;
  }
  &::before {
    content: counter(step);
    position: absolute;
    left: 0;
    top: -3px;
    display: grid;
    place-items: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    color: ${THEME.COLOR_ACCENT};
    background: ${THEME.ACCENT_SURFACE};
    font-size: 13px;
    font-weight: 700;
  }
`;
export const GuideImage = styled.img `
  display: block;
  width: 100%;
  height: auto;
  border: 1px solid ${THEME.BORDER};
  border-radius: 8px;
  margin-top: 16px;
`;
//# sourceMappingURL=manual-guide.js.map